import { render, staticRenderFns } from "./trans_back.vue?vue&type=template&id=31ff8cbc&scoped=true"
import script from "./trans_back.vue?vue&type=script&lang=js"
export * from "./trans_back.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff8cbc",
  null
  
)

export default component.exports